//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscAI(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7.75444 8.3773L10.0154 4.48928L12.2763 8.3773L12.6381 8.73906L16.5261 11L12.6381 13.261L12.2763 13.6227L10.0154 17.5108L8.23244 14.4447L6.67756 15.7494L9.15093 20.0027H10.8799L13.8722 14.8569L19.0181 11.8645V10.1356L13.8722 7.14316L10.8799 1.99731H9.15093L6.15854 7.14316L1.0127 10.1356V11.8645L5.25557 14.3318L6.88415 12.9652L3.50466 11L7.39268 8.73906L7.75444 8.3773Z" fill="currentColor" /><path d="M19.5159 15.9912L20.7969 18.194L22.9996 19.4749L20.7969 20.7558L19.5159 22.9586L18.235 20.7558L16.0322 19.4749L18.235 18.194L19.5159 15.9912Z" fill="currentColor" /></svg>;
}
export default IconMiscAI;